import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Calendar, ArrowRight, Clock} from 'lucide-react'

const posts = [
  {
    title: "Como aprender inglês sozinho: guia completo para iniciantes",
    excerpt: "Descubra as melhores estratégias para começar a aprender inglês de forma autônoma, com dicas práticas e recursos gratuitos.",
    date: "15 Jan 2025",
    readTime: "8 min",
    category: "Dicas",
    color: "#0E8EA0",
  },
  {
    title: "Inglês para carreira: por que o idioma é essencial no mercado de trabalho",
    excerpt: "Entenda como o domínio do inglês pode abrir portas profissionais e acelerar sua carreira em qualquer área de atuação.",
    date: "10 Jan 2025",
    readTime: "6 min",
    category: "Carreira",
    color: "#B038B2",
  },
  {
    title: "Inteligência artificial no ensino de idiomas: o futuro chegou",
    excerpt: "Saiba como a IA está revolucionando o aprendizado de inglês e como a English Work utiliza essa tecnologia.",
    date: "05 Jan 2025",
    readTime: "7 min",
    category: "Tecnologia",
    color: "#F5C542",
  },
  {
    title: "5 erros comuns que impedem você de falar inglês fluente",
    excerpt: "Conheça os erros mais frequentes de quem estuda inglês e aprenda como evitá-los para acelerar sua fluência.",
    date: "28 Dez 2024",
    readTime: "5 min",
    category: "Dicas",
    color: "#0E8EA0",
  },
  {
    title: "O método GO: como funciona a metodologia da English Work",
    excerpt: "Entenda o método exclusivo que combina as quatro habilidades do idioma com tecnologia e prática constante.",
    date: "20 Dez 2024",
    readTime: "9 min",
    category: "Metodologia",
    color: "#B038B2",
  },
  {
    title: "Depoimentos: como o EW Pass mudou a vida dos nossos alunos",
    excerpt: "Histórias reais de pessoas que destravaram o inglês e conquistaram novas oportunidades com a English Work.",
    date: "15 Dez 2024",
    readTime: "6 min",
    category: "Histórias",
    color: "#F5C542",
  },
]

export default function Blog() {
  const section1 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Blog English Work"
        subtitle="Dicas, novidades e conteúdos sobre aprendizado de inglês, carreira e tecnologia educacional."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post) => (
              <article
                key={post.title}
                className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300 group cursor-pointer"
              >
                <div className="h-2 w-full" style={{ backgroundColor: post.color }} />
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <span
                      className="text-xs font-bold px-3 py-1 rounded-full text-white"
                      style={{ backgroundColor: post.color }}
                    >
                      {post.category}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-[#0E8EA0] transition-colors leading-snug">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-5">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-gray-400">
                    <div className="flex items-center gap-3">
                      <span className="flex items-center gap-1">
                        <Calendar size={12} /> {post.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock size={12} /> {post.readTime}
                      </span>
                    </div>
                    <ArrowRight size={16} className="text-gray-300 group-hover:text-[#0E8EA0] transition-colors" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
